"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButtonSizes = exports.IconButtonThemeTypes = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Heart_1 = require("../Icons/Heart/Heart");
var b2c_theme_1 = require("../Theme/b2c-theme");
var IconButtonThemeTypes;
(function (IconButtonThemeTypes) {
    IconButtonThemeTypes["success"] = "success";
    IconButtonThemeTypes["white"] = "white";
})(IconButtonThemeTypes = exports.IconButtonThemeTypes || (exports.IconButtonThemeTypes = {}));
var IconButtonSizes;
(function (IconButtonSizes) {
    IconButtonSizes["xSmall"] = "xSmall";
    IconButtonSizes["small"] = "small";
    IconButtonSizes["default"] = "default";
    IconButtonSizes["medium"] = "medium";
    IconButtonSizes["large"] = "large";
})(IconButtonSizes = exports.IconButtonSizes || (exports.IconButtonSizes = {}));
var ButtonElement = styled_components_1.default.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  border-width: 2px;\n  padding-left: 0;\n  padding-right: 0;\n  border-style: solid;\n  ", "\n  ", "\n  ", "\n  border-radius: 50%;\n  outline: 0;\n\n  &:focus {\n    border-color: ", ";\n  }\n"], ["\n  width: ", "px;\n  height: ", "px;\n  border-width: 2px;\n  padding-left: 0;\n  padding-right: 0;\n  border-style: solid;\n  ", "\n  ", "\n  ", "\n  border-radius: 50%;\n  outline: 0;\n\n  &:focus {\n    border-color: ", ";\n  }\n"])), function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var showBackground = _a.showBackground, showBorder = _a.showBorder;
    var borderColor = showBackground
        ? b2c_theme_1.colors.button.iconButtonBackground
        : b2c_theme_1.colors.button.iconButtonBorderDark;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), showBorder
        ? "\n            border-color: ".concat(borderColor, ";\n          ")
        : "border-color: transparent;");
}, function (_a) {
    var showBackground = _a.showBackground, theme = _a.theme;
    var backgroundColor;
    if (showBackground) {
        backgroundColor = b2c_theme_1.colors.button.iconButtonBackground;
        switch (theme) {
            case IconButtonThemeTypes.success:
                backgroundColor = b2c_theme_1.colors.button.success;
                break;
            case IconButtonThemeTypes.white:
                backgroundColor = b2c_theme_1.colors.button.white;
                break;
            default:
                backgroundColor = b2c_theme_1.colors.button.iconButtonBackground;
                break;
        }
        return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), backgroundColor);
    }
    else {
        return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        background-color: transparent;\n      "], ["\n        background-color: transparent;\n      "])));
    }
}, function (_a) {
    var disabled = _a.disabled;
    return disabled
        ? "opacity: 0.4; cursor: not-allowed;"
        : "opacity: 1; cursor: pointer;";
}, b2c_theme_1.colors.button.outline.default);
var IconContainer = styled_components_1.default.i(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var IconButton = function (props) {
    var defaultProps = {
        disabled: false,
        showBackground: true,
        showBorder: true,
    };
    var _a = __assign(__assign({}, defaultProps), props), ariaLabel = _a.ariaLabel, children = _a.children, disabled = _a.disabled, onClick = _a.onClick, showBackground = _a.showBackground, showBorder = _a.showBorder, size = _a.size, theme = _a.theme, rest = __rest(_a, ["ariaLabel", "children", "disabled", "onClick", "showBackground", "showBorder", "size", "theme"]);
    var _b = (0, react_1.useState)(IconButtonSizes.default), iconSize = _b[0], setIconSize = _b[1];
    var _c = (0, react_1.useState)(b2c_theme_1.defaultIconButtonSize), buttonSize = _c[0], setButtonSize = _c[1];
    var _d = (0, react_1.useState)(Heart_1.IconColorThemes.uiDark1), iconColor = _d[0], setIconColor = _d[1];
    (0, react_1.useEffect)(function () {
        switch (size) {
            case IconButtonSizes.xSmall:
                setIconSize(b2c_theme_1.IconSizes.xSmall);
                break;
            case IconButtonSizes.small:
                setIconSize(b2c_theme_1.IconSizes.small);
                break;
            case IconButtonSizes.medium:
                setIconSize(b2c_theme_1.IconSizes.medium);
                break;
            case IconButtonSizes.large:
                setIconSize(b2c_theme_1.IconSizes.medium);
                break;
            default:
                setIconSize(IconButtonSizes.default);
        }
    }, [size]);
    (0, react_1.useEffect)(function () {
        switch (size) {
            case IconButtonSizes.xSmall:
                setButtonSize(16);
                break;
            case IconButtonSizes.small:
                setButtonSize(24);
                break;
            case IconButtonSizes.medium:
                setButtonSize(32);
                break;
            case IconButtonSizes.large:
                setButtonSize(40);
                break;
            default:
                setButtonSize(b2c_theme_1.defaultIconButtonSize);
        }
    }, [size]);
    (0, react_1.useEffect)(function () {
        theme === IconButtonThemeTypes.success
            ? setIconColor(Heart_1.IconColorThemes.white)
            : setIconColor(Heart_1.IconColorThemes.uiDark1);
    }, [theme]);
    var onClickProxy = onClick
        ? function (event) {
            if (!disabled) {
                onClick(event);
            }
        }
        : undefined;
    return (react_1.default.createElement(ButtonElement, __assign({ "aria-label": ariaLabel, "data-testid": "icon-button", disabled: disabled, size: buttonSize, type: "button", onClick: onClickProxy, showBackground: showBackground, showBorder: showBorder, theme: theme }, rest), children && react_1.default.isValidElement(children) ? (react_1.default.createElement(IconContainer, { "data-testid": "icon-button-icon-container" }, react_1.default.cloneElement(children, {
        color: children.props.color || iconColor,
        focusable: 'false',
        'data-testid': 'icon-button-icon',
        size: iconSize,
    }))) : null));
};
exports.default = IconButton;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=IconButton.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/IconButton/IconButton.js
// module id = 208
// module chunks = 81